export default "<ion-app>\n  <ion-router-outlet></ion-router-outlet>\n\n</ion-app>\n";